import Footer from "./Footer";
import Header from "./Header";
import PageTitle from "./PageTitle";
import DownFooter from "./DownFooter";

const all = { Header, PageTitle, Footer, DownFooter };

export default all;
